module.exports = __webpack_public_path__ + "static/media/room-2.052c7681.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-2.jpeg
// module id = 77
// module chunks = 0